import React from 'react';

const ALL_SIZES = ['S', 'M', 'L', 'XL', '2XL', '3XL', '4XL', '5XL', '4', '6', '8', '10', '12', '14', '16', 'UNICA', 'S/M', 'L/XL'];

export const SizeFilters = ({ selectedSize, onSizeChange }) => {
  return (
    <div className="flex items-center gap-2 flex-wrap">
      <span className="text-xs font-bold text-gray-400 uppercase">Talla:</span>
      <button onClick={() => onSizeChange(null)}
        className={`px-3 py-1 rounded-lg font-bold text-xs transition-all ${
          selectedSize === null ? 'bg-[#39FF14] text-black' : 'bg-[#1A1A1A] text-gray-400 border border-gray-700'}`}>
        TODAS
      </button>
      {ALL_SIZES.map((size) => (
        <button key={size} onClick={() => onSizeChange(size)}
          className={`px-3 py-1 rounded-lg font-bold text-xs transition-all ${
            selectedSize === size ? 'bg-[#39FF14] text-black' : 'bg-[#1A1A1A] text-gray-400 border border-gray-700'}`}>
          {size}
        </button>
      ))}
    </div>
  );
};
